import { useContext, useState, useEffect } from 'react';
// Material UI
import {
  Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Chip, Dialog, FormControl, FormControlLabel, FormLabel,
  Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip,
  makeStyles
} from '@material-ui/core';
import { format as formatDate, isPast, set } from 'date-fns';
// icons
import AddIcon from '@material-ui/icons/Add';
import EmailIcon from '@material-ui/icons/Email';
import DevicesDialog from './DevicesDialog';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import {
  FORMAT_OPTIONS,
  FREQUENCY_OPTIONS,
  TYPE_VARIABLES,
} from './helpers';
// datepickers
import DatepickerSingle from '../DatePicker/DatepickerSingle';
import UserContext from '../../context/UserContext';
import { isValidEmail } from '../../helpers/common';
import {
  createAutomaticReport,
  createReport,
  deleteReport,
  editReport,
  updateAutomaticReport,
} from '../../services/reports';
import ConfirmationDialog from './ConfirmationDialog';
import { convertToTimeZone } from 'date-fns-timezone';
//Servicios
import { getStatusNodes } from '../../services/meters';
import DatasetFilter from './Reports/DatasetFilter';
import NodesContext from '../../context/NodesContext';
import { get_vars_Automate_byId } from '../../services/plc_automate';

const useStyles = makeStyles(theme => ({
  devicesBtn: {
    margin: theme.spacing(3, 1),
  },
  dialogTitle: {
    paddingBottom: 0,
  },
  hint: {
    backgroundColor: 'rgba(0, 0, 0, 0.38)',
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'rgb(54, 143, 193);',
    },
    minWidth: 24
  },
  formGrow: {
    flexGrow: 1,
  },
  addBtn: {
    margin: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    '&:hover': {
      backgroundColor: 'rgb(54, 143, 193);',
    },
  },
  filterChip: {
    margin: theme.spacing(0.5),
    '@media (max-width: 700px)': {
      width: '250px',
    },
  },

  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    '& .MuiTypography-body1': {
      fontSize: '0.75rem',
    },
  },
  error: {
    marginLeft: theme.spacing(1),
    color: '#af2c47',
    fontSize: '0.75rem',
  },
  emailContainer: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 700px)': {
      flexDirection: 'column',
      gap: theme.spacing(1)
    },
  },
  email: {
    marginLeft: theme.spacing(1),
    '& .MuiInputBase-input': {
      fontSize: '12px',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  help: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    padding: theme.spacing(0.5),
  },
  pending: {
    color: '#af2c47',
    fontSize: '0.75rem',
    padding: theme.spacing(0.5),
    textAlign: 'center'
  },
}));

function Filter({
  filterOptions,
  setFilterOptions,
  togglePanel,
  handleSubmit,
}) {
  const classes = useStyles();
  const { nodes } = useContext(NodesContext);
  const { plan } = useContext(UserContext);
  const [showDevices, setShowDevices] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [waiting, setWaiting] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [statusNodes, setStatusNodes] = useState([]);
  const enabledItems = plan?.sections['ALERTAS_REPORTES'].filter(item => item.enabled);
  console.log('enabledItems', enabledItems)
  const [variables, setVariables] = useState(enabledItems);
  const [indexDatasetSelected, setIndexDatasetSelected] = useState(null);
  const [showDatasetFilter, setShowDatasetFilter] = useState(false);
  const instantPeriods = plan?.sections['RANGOS_INSTANTANEOS']?.period_info?.[0]?.values
  const [automateVars, setAutomateVars] = useState([])
  const [originalAutomateVars, setOriginalAutomateVars] = useState([])
  const [granularities, setGranularities] = useState([])
  const [selectedGranularity, setSelectedGranularity] = useState([])
  const [errorReport, setErrorReport] = useState(null)

  //Verifica status de el medidor.
  useEffect(() => {
    const getStatusNodesAux = async () => {
      let res = await getStatusNodes()
      let arry = res.data
      setStatusNodes(arry)
    }
    getStatusNodesAux()
    getAutomateVars();
    loadSelectedGranularity();
    filterVariables(filterOptions.type_variable)
    // setVariables(allvars)
  }, [])

  useEffect(() => {
    console.log({ filterOptions })
    // setVariables(allvars)
  }, [filterOptions])

  const loadSelectedGranularity = () => {

    if (!filterOptions?.frequency_date) {
      setSelectedGranularity(null);
      return;
    }
    let selectedPeriod = ""

    for (const item of enabledItems) {
      const period = item.periods?.find(
        p => p.key === filterOptions.frequency_date
      );

      if (period) {
        setSelectedGranularity(period);
        selectedPeriod = item.endpoint?.key
        setGranularities(getGranularitiesByEndpoint(enabledItems, selectedPeriod));
        return;
      }
    }
    setSelectedGranularity(null);
  }

  const getAutomateVars = async () => {
    let res = await get_vars_Automate_byId();
    let varAutomates = res?.data?.sections['VARIABLES'] || [];
    varAutomates.forEach(v => v.isVarAutomate = true);
    setAutomateVars(varAutomates);
    setOriginalAutomateVars(varAutomates);
  }

  const handleFilterChange = e => {
    if (e.target.type === 'checkbox') {
      return setFilterOptions({
        ...filterOptions,
        [e.target.name]: JSON.parse(e.target.checked),
      });

    }
    if (e.target.type === 'number') {
      return setFilterOptions({
        ...filterOptions,
        [e.target.name]: parseInt(e.target.value),
      });
    }
    if (e.target.name === 'variable') {
      const chosen_range = e.target.value.length === 1 ? objectCatalog[e.target.value]?.periods[0]?.values?.[0]?.key : filterOptions.chosen_range;
      const frequency_date = e.target.value.length === 1 ? objectCatalog[e.target.value]?.periods[0].key : filterOptions.frequency_date;

      setFilterOptions({
        ...filterOptions,
        variable: e.target.value || [],
        tabValue: 0,
        chosen_range,
        frequency_date
      });
    }

    if (e.target.name === "type_variable") {
      const endpointKey = e.target.value;

      filterVariables(endpointKey);

      const granularities = getGranularitiesByEndpoint(
        enabledItems,
        endpointKey
      );
      setGranularities(granularities);

      if (endpointKey === "VALIDATE_INSTANT") {
        setAutomateVars(originalAutomateVars);
      } else {
        setAutomateVars([]);
      }

      // 🔥 LIMPIEZA TOTAL
      setSelectedDataset(null);
      setIndexDatasetSelected(null);
      setShowDatasetFilter(false);

      setFilterOptions(prev => ({
        ...prev,
        type_variable: endpointKey,
        datasets: [],
        chosen_range: "",
        frequency_date: "",
      }));

      return;
    }


    if (e.target.name === 'frequency_date') {
      setFilterOptions({
        ...filterOptions,
        [e.target.name]: e.target.value,
        chosen_range: ''
      });
      let selected = granularities.find(granularity => granularity?.key === e.target.value)
      setSelectedGranularity(selected)
    }
    else {
      setFilterOptions({ ...filterOptions, [e.target.name]: e.target.value });
    }

  };

  useEffect(() => {
    if (!filterOptions.datasets || filterOptions.datasets.length === 0) {
      setSelectedDataset(null);
      setIndexDatasetSelected(null);
      setShowDatasetFilter(false);
    }
  }, [filterOptions.datasets]);

  const getGranularitiesByEndpoint = (items, endpointKey) => {
    const map = new Map();

    items.forEach(item => {
      if (item.endpoint?.key === endpointKey) {
        item.periods?.forEach(period => {
          if (!map.has(period.key)) {
            map.set(period.key, period);
          }
        });
      }
    });

    return Array.from(map.values());
  };

  const filterVariables = (endpointKey) => {
    const varAux = enabledItems.filter(
      item => item?.endpoint?.key === endpointKey
    );
    setVariables(varAux);
  }

  const handleDeleteOval = indexDataset => {
    const datasets = filterOptions.datasets.filter(
      (dataset, i) => i !== indexDataset
    );
    setFilterOptions({ ...filterOptions, datasets });
  };

  const handleClickOval = (dataset, index) => {
    console.log({ filterOptions })
    console.log('datasetsekeccuiad', dataset)
    setShowDatasetFilter(true);
    setSelectedDataset(dataset)
    setIndexDatasetSelected(index);
  };

  const handleChangeEmail = e => {
    setEmail(e.target.value);
    setErrorMessage('');
  };

  const handleAddEmail = () => {
    if (filterOptions.emails.indexOf(email) !== -1) {
      setErrorMessage(`${email} ya forma parte del listado`);
      return;
    }

    const emails = [...filterOptions.emails, email];
    setEmail('');
    setFilterOptions({ ...filterOptions, emails });
  };

  const handleDeleteEmail = email => {
    const emails = filterOptions.emails.filter(
      savedEmail => savedEmail !== email
    );
    setFilterOptions({ ...filterOptions, emails });
  };

  const handlePreDeleteReport = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteReport = async () => {
    try {
      await deleteReport(filterOptions.id);
      const notification = {
        isOpen: true,
        message: 'Reporte eliminado exitosamente',
        severity: 'success',
        isOpenModal: false
      };
      setIsDeleteDialogOpen(false);
      handleSubmit(notification);
    } catch (error) {
      let msg = 'Ocurrió un error inesperado';
      if (error.response) {
        msg = `${error.response.data.detail}.`
      }

      handleSubmit({
        isOpen: true,
        message: msg,
        severity: 'error',
        isOpenModal: false
      });
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleCreate = async () => {
    try {
      const {
        report_name,
        type,
        format,
        report_automatic,
        frequency_date,
        chosen_range,
        frequency,
        frequency_custom,
        dateFrom,
        emails,
        type_variable
      } = filterOptions;
      let filter;
      setErrorReport('');
      setWaiting(true);
      let report = {
        report_name,
        type,
        format,
        datasets: filterOptions.datasets,
        filter,
        chosen_range,
        type_variable
      }

      if (type_variable === "VALIDATE_HISTORY") {
        report.frequency_date = frequency_date
      }

      const res = await createReport(report);

      let notification = {
        isOpen: true,
        message: 'Reporte creado exitosamente',
        severity: 'success',
        isOpenModal: false
      };

      // Si tengo report_automatic en true debo esperar el resultado de la creación del reporte para crear el reporte automático.
      const reportId = res.data?.id;
      if (report_automatic) {
        const formattedDate = formatDate(
          dateFrom ?? oneHourLater,
          'dd/MM/yyyy HH:mm:ss'
        );

        const payload = {
          frequency: frequency !== 'CUSTOM' ? frequency : null,
          frequency_custom: frequency === 'CUSTOM' ? frequency_custom : null,
          start: formattedDate,
          emails: emails.join(', '),
        };

        await createAutomaticReport(reportId, payload);

        notification = {
          isOpen: true,
          message: 'Reporte automático creado exitosamente',
          severity: 'success',
          isOpenModal: false
        };
      }

      setWaiting(false);

      handleSubmit(notification);
    } catch (error) {
      console.error(error);
      let msg = 'Ocurrió un error inesperado';
      if (error.response) {
        if (error?.response?.data?.msg) {
          msg = `${error?.response?.data?.msg}.`;
        }
        if (error?.response?.data?.type) {
          msg = `${error.response.data.type}.`;
        }
      }
      setErrorReport(msg)
      setWaiting(false);
    }
  };

  const handleEdit = async () => {
    try {
      const {
        id,
        report_name,
        type,
        format,
        report_automatic,
        reportAutomatic,
        frequency_date,
        chosen_range,
        frequency,
        frequency_custom,
        dateFrom,
        emails,
        datasets,
        type_variable
      } = filterOptions;
      let filter;
      setErrorReport('')
      let report = {
        report_name,
        type,
        format,
        datasets,
        report_automatic,
        filter,
        chosen_range,
        type_variable
      }

      if (type_variable === "VALIDATE_HISTORY") {
        report.frequency_date = frequency_date
      }

      setWaiting(true);
      await editReport(id, report);

      let notification = {
        isOpen: true,
        message: 'Reporte editado exitosamente',
        severity: 'success',
        isOpenModal: false
      };

      if (report_automatic) {
        const formattedDate = formatDate(dateFrom, 'dd/MM/yyyy HH:mm:ss');

        const payload = {
          frequency: frequency !== 'CUSTOM' ? frequency : null,
          frequency_custom: frequency === 'CUSTOM' ? frequency_custom : null,
          start: formattedDate,
          emails: emails.join(', '),
        };

        if (!reportAutomatic) {
          // Si report_automatic es true y reportAutomatic es null debo crear un nuevo reporte automático
          // console.log('Creo nuevo reporte automático');
          await createAutomaticReport(id, payload);
          notification = {
            isOpen: true,
            message: 'Reporte automático creado exitosamente',
            severity: 'success',
            isOpenModal: false
          };
        } else {
          // Su report_automatic es true y reportAutomatic no es null debo actualizar el reporte existente
          // console.log('Actualizo reporte automático');
          await updateAutomaticReport(id, reportAutomatic.id, payload);
          notification = {
            isOpen: true,
            message: 'Reporte automático editado exitosamente',
            severity: 'success',
            isOpenModal: false
          };
        }
      }
      setWaiting(false);
      handleSubmit(notification);

    } catch (error) {
      let msg = 'Ocurrió un error inesperado';
      if (error.response) {
        if (error.response?.data.msg) {
          msg = `${error.response.data.msg}.`;
        }
        // TODO Deberíamos recibir todos los errores en error.response.data.msg
        if (error.response?.data.type) {
          msg = `${error.response.data.type}.`;
        }
      }
      setErrorReport(msg)
      setWaiting(false);
    }
  };

  const now = new Date();
  now.setMinutes(0);

  const a = convertToTimeZone(now, { timeZone: plan?.info?.tz })

  const oneHourLater = new Date(new Date(a).getTime() + 60 * 60 * 1000);

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (isValidEmail(email)) {
        handleAddEmail();
      } else {
        setErrorMessage('El mail ingresado es inválido');
      }
    }
  };


  const objectCatalog = {};
  enabledItems.forEach(item => {
    objectCatalog[item.key] = {
      key: item.key,
      name: item.name,
      periods: item.periods,
      endpoint_key: item?.endpoint?.key,
    };
  });

  const hasSomeVirtualNodes = () => {
    return filterOptions.devices.some(item => item?.virtual);
  };

  const firstDataset = filterOptions?.datasets?.[0] || null;

  // const firstDatasetFirstVariable = !Array.isArray(firstDataset?.variable) ? firstDataset?.variable?.split(',')[0] : firstDataset?.variable?.[0];
  const handleCloseDatasetFilter = () => {
    setShowDatasetFilter(false);
  }

  const getDatasetName = (dataset) => {
    let device = findNodeById(nodes, Number(dataset.nodes[0]));
    return `${device?.nombre} - ${dataset?.variables?.length} variables` || '-';
  }

  const findNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }

      if (Array.isArray(node.hijos) && node.hijos.length > 0) {
        const found = findNodeById(node.hijos, id);
        if (found) return found;
      }
    }
    return null;
  };

  return (
    <>
      <Grid container spacing={4} component='form'>
        {/* Nombre del reporte */}
        <Grid item xs={12}>
          <Box display='flex' alignItems='center' ml={2}>
            <Tooltip
              title='Indique el nombre del reporte'
              arrow
              placement='right'
            >
              <Box className={classes.hint}>1</Box>
            </Tooltip>
            <FormControl className={classes.formGrow}>
              <TextField
                label='Nombre del reporte'
                name='report_name'
                value={filterOptions.report_name || ''} //Contemplo casos creado con nombre=null con Postman
                onChange={handleFilterChange}
                color='primary'
              />
            </FormControl>
          </Box>
        </Grid>

        {/* Tipo de reporte */}
        {/* <Grid item xs={12}>
          <Box display='flex' alignItems='center' ml={2}>
            <Tooltip title='Elija el tipo de reporte' arrow placement='right'>
              <Box className={classes.hint}>2</Box>
            </Tooltip>
            <FormControl className={classes.formGrow}>
              <InputLabel id='typeLabel'>Tipo reporte</InputLabel>
              <Select
                labelId='typeLabel'
                name='type'
                value={filterOptions.type}
                onChange={handleFilterChange}
              >
                {TYPE_OPTIONS.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid> */}

        {/* Formato del reporte */}
        <Grid item xs={12}>
          <Box display='flex' alignItems='center' ml={2}>
            <Tooltip
              title='En caso de que sea de tipo tabla elija el formato del reporte'
              arrow
              placement='right'
            >
              <Box className={classes.hint}>2</Box>
            </Tooltip>
            <FormControl className={classes.formGrow}>
              <InputLabel id='formatLabel'>Formato reporte</InputLabel>
              <Select
                labelId='formatLabel'
                name='format'
                value={filterOptions.format}
                onChange={handleFilterChange}
                disabled={filterOptions.type === 'DASHBOARD'}
              >
                {FORMAT_OPTIONS.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box display='flex' alignItems='center' ml={2}>
            <Tooltip title='Elija el tipo de reporte' arrow placement='right'>
              <Box className={classes.hint}>3</Box>
            </Tooltip>
            <FormControl className={classes.formGrow}>
              <InputLabel id='typeLabel'>Tipo de variable</InputLabel>
              <Select
                labelId='typeLabel'
                name='type_variable'
                value={filterOptions.type_variable}
                onChange={handleFilterChange}
              >
                {TYPE_VARIABLES.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>


        {/* <Grid item xs={12}>
          <Box display='flex' alignItems='center' ml={2}>
            <Tooltip title='Elija el tipo de reporte' arrow placement='right'>
              <Box className={classes.hint}>4</Box>
            </Tooltip>
            <FormControl className={classes.formGrow}>
              <InputLabel id='typeLabel'>Tipo de variable</InputLabel>
              <Select
                labelId='typeLabel'
                name='type_variable'
                value={filterOptions.type_variable}
                onChange={handleFilterChange}
              >
                {TYPE_VARIABLES.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid> */}


        {/* Si hay automate seleccionado muestra periodos */}
        {filterOptions.type_variable === 'VALIDATE_INSTANT' ? (
          <Grid item xs={12}>
            <Box display='flex' alignItems='center' ml={2}>
              <Tooltip
                title='Seleccione la granularidad de la variable que desea obtener y el período de la consulta'
                arrow
                placement='right'
              >
                <Box className={classes.hint}>4</Box>
              </Tooltip>
              <FormControl component='fieldset' className={classes.formGrow}>
                <InputLabel id='periodLabel'>Período</InputLabel>
                <Select
                  value={filterOptions.chosen_range}
                  onChange={handleFilterChange}
                  labelId='periodLabel'
                  name='chosen_range'
                >
                  {
                    instantPeriods?.map(option => (
                      <MenuItem
                        key={option.key}
                        value={option.key}
                      >
                        {option.name}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Box>
            {
              firstDataset?.variables?.length === 0 &&
              <Box className={classes.help}>Debe elegir una variable antes de elegir el período.</Box>
            }
          </Grid>
        ) :
          (
            <>
              {/*Granularidad*/}
              < Grid item xs={12}>
                <Box display='flex' alignItems='center' ml={2}>
                  <Tooltip
                    title='Seleccione la granularidad de la variable que desea obtener y el período de la consulta'
                    arrow
                    placement='right'
                  >
                    <Box className={classes.hint}>4</Box>
                  </Tooltip>


                  <FormControl component='fieldset' className={classes.formGrow}>
                    <InputLabel id='granularityLabel'>Granularidad</InputLabel>
                    <Select
                      value={filterOptions.frequency_date}
                      onChange={handleFilterChange}
                      labelId='granularityLabel'
                      name='frequency_date'
                    >
                      {
                        granularities?.map(option => (
                          <MenuItem
                            key={option.key}
                            value={option.key}
                          >
                            {option.label}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>


                </Box>
                {
                  (!firstDataset?.variables || firstDataset?.variables === "") &&
                  <Box className={classes.help}>Debe elegir una variable antes de elegir la granularidad.</Box>
                }

              </Grid>
              <Grid item xs={12}>
                {/*Periodo*/}
                <Box display='flex' alignItems='center' ml={2}>
                  <Tooltip
                    title='Seleccione la granularidad de la variable que desea obtener y el período de la consulta'
                    arrow
                    placement='right'
                  >
                    <Box className={classes.hint}>5</Box>
                  </Tooltip>

                  {selectedGranularity?.values?.length > 0 && <FormControl component='fieldset' className={classes.formGrow}>
                    <InputLabel id='periodLabel'>Período</InputLabel>
                    <Select
                      value={filterOptions.chosen_range}
                      onChange={handleFilterChange}
                      labelId='periodLabel'
                      name='chosen_range'
                    >
                      {
                        selectedGranularity?.values?.map(option => (
                          <MenuItem
                            key={option.key}
                            value={option.key}
                          >
                            {option.name}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>}

                </Box>
                {
                  (!firstDataset?.variables || firstDataset?.variables === "") &&
                  <Box className={classes.help}>Debe elegir una variable antes de elegir el período.</Box>
                }

              </Grid>
            </>
          )
        }

        <Grid item xs={12}>
          <Box
            display='flex'
            alignItems='center'
            flexWrap='wrap'
            minHeight={48}
            ml={2}
          >
            <Tooltip
              title='Elija los dataset que desea añadir al reporte'
              arrow
              placement='right'
            >
              <Box className={classes.hint}>{filterOptions.type_variable === 'VALIDATE_INSTANT' ? '5' : '6'}</Box>
            </Tooltip>
            <Box className={classes.label}>Agregar dataset</Box>
            <Tooltip
              title='Haga click aquí para agregar un dataset'
              arrow
              placement='right'
            >
              <span>
                <IconButton
                  className={classes.addBtn}
                  aria-label='agregar dataset'
                  onClick={() => {
                    setShowDatasetFilter(true);
                    setSelectedDataset(null);
                    setIndexDatasetSelected(null);
                  }}
                >
                  <AddIcon fontSize='small' />
                </IconButton>
              </span>
            </Tooltip>
            {(filterOptions.datasets && filterOptions.datasets?.length > 0) &&
              filterOptions.datasets?.map((dataset, index) => {
                if (!dataset) return null;
                return (
                  <Chip
                    key={index}
                    icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                    label={`${dataset.alias || getDatasetName(dataset)}`}
                    clickable
                    color='primary'
                    onDelete={() => handleDeleteOval(index)}
                    className={classes.filterChip}
                    onClick={() => handleClickOval(dataset, index)}
                  />
                )
              })}
          </Box>
        </Grid>

        {/* Envío automático */}
        <Grid item xs={12} style={{ margin: '0 16px', padding: 0 }}>
          <Accordion expanded={filterOptions.report_automatic}>
            <AccordionSummary>
              <Box display='flex' alignItems='center'>
                <Tooltip
                  title='Elija si desea programar el envío automático del reporte'
                  arrow
                  placement='right'
                >
                  <Box className={classes.hint}>{filterOptions.type_variable === 'VALIDATE_INSTANT' ? '6' : '7'}</Box>
                </Tooltip>
                <FormControl className={classes.formGrow}>
                  <FormControlLabel
                    className={classes.label}
                    control={
                      <Checkbox
                        checked={filterOptions.report_automatic}
                        color='primary'
                        name='report_automatic'
                        onChange={handleFilterChange}
                      />
                    }
                    label='Programar envío automático'
                  />
                </FormControl>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container>
                {/* Correos */}
                <Grid item xs={12}>
                  <Box display='flex' alignItems='center' minHeight={48}>
                    <Tooltip
                      title='Ingrese los correos en los que desea recibir el reporte'
                      arrow
                      placement='right'
                    >
                      <Box className={classes.hint}>{filterOptions.type_variable === 'VALIDATE_INSTANT' ? '7' : '8'}</Box>
                    </Tooltip>

                    <Box className={classes.label}>Agregar Email</Box>
                  </Box>
                  <Box className={classes.emailContainer}>
                    <TextField
                      className={classes.email}
                      name='email'
                      value={email}
                      error={email !== '' && !Boolean(isValidEmail(email))}
                      onChange={handleChangeEmail}
                      onKeyDown={handleKeyDown}
                      variant='outlined'
                      size='small'
                      placeholder={filterOptions.emails.length > 0 ? 'Ingrese un nuevo email' : 'Ingrese un email'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <EmailIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Button
                      variant='outlined'
                      onClick={handleAddEmail}
                      disabled={!isValidEmail(email)}
                    >
                      Confirmar
                    </Button>
                    <Box className={classes.error}>{errorMessage}</Box>
                  </Box>

                  <Grid item xs={12}>
                    {filterOptions.emails.length > 0 &&
                      filterOptions.emails.map(email => (
                        <Chip
                          key={email}
                          icon={<EmailIcon style={{ fontSize: '15px' }} />}
                          label={email}
                          color='primary'
                          onDelete={() => handleDeleteEmail(email)}
                          className={classes.filterChip}
                        />
                      ))}
                  </Grid>
                </Grid>

                {/* Frecuencia */}
                <Grid item xs={12} sm={6}>
                  <Box display='flex' alignItems='center' minHeight={64}>
                    <Tooltip
                      title='Elija la frecuencia con la cual desea recibir el reporte'
                      arrow
                      placement='right'
                    >
                      <Box className={classes.hint}>{filterOptions.type_variable === 'VALIDATE_INSTANT' ? '8' : '9'}</Box>
                    </Tooltip>
                    <FormControl className={classes.formGrow}>
                      <InputLabel id='frequencyLabel'>Frecuencia</InputLabel>
                      <Select
                        labelId='frequencyLabel'
                        name='frequency'
                        value={filterOptions.frequency}
                        onChange={handleFilterChange}
                      >
                        {FREQUENCY_OPTIONS
                          .filter(option => {
                            // No quiero que los gratuitos puedan elegir DAILY.
                            if (plan?.info?.plan === 'Gratuito' && option.value === 'DAILY') {
                              return false;
                            }
                            return true;
                          })
                          .map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                {/* Frecuencia Personalizada */}
                <Grid item xs={12} sm={6}>
                  {filterOptions.frequency === 'CUSTOM' && (
                    <Box
                      display='flex'
                      alignItems='center'
                      minHeight={64}
                      style={{ marginTop: '2px' }}
                      ml={2}
                    >
                      <FormControl>
                        <FormLabel className={classes.label}>
                          Recibir reporte cada
                        </FormLabel>
                        <TextField
                          name='frequency_custom'
                          value={filterOptions.frequency_custom}
                          onChange={handleFilterChange}
                          type='number'
                          InputProps={{
                            endAdornment: 'días',
                          }}
                          inputProps={{
                            min: plan?.info?.plan === 'Gratuito' ? 7 : 1,
                          }}

                        />
                      </FormControl>
                    </Box>
                  )}
                </Grid>

                {/* Datepicker de inicio */}
                <Grid item xs={12}>
                  <Box display='flex' alignItems='center'>
                    <Tooltip
                      title='Elija el día en que desea comenzar a recibir el reporte'
                      arrow
                      placement='right'
                    >
                      <Box className={classes.hint}>{filterOptions.type_variable === 'VALIDATE_INSTANT' ? '9' : '10'}</Box>
                    </Tooltip>
                    <label className={classes.label}>Próximo envío</label>
                  </Box>
                  <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                  >
                    <DatepickerSingle
                      startDate={filterOptions.dateFrom ?? oneHourLater}
                      setDate={setFilterOptions}
                    />
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>


        {/* Botonera */}
        <Grid item xs={12}>
          {(!firstDataset?.nodes || firstDataset?.nodes?.length === 0) && (
            <Box className={classes.pending}>
              Debe seleccionar al menos un dispositivo.
            </Box>
          )}

          {(!firstDataset?.variables || firstDataset?.variables === "") && (
            <Box className={classes.pending}>
              Debe seleccionar una variable.
            </Box>
          )}

          {filterOptions.report_automatic && filterOptions.emails.length === 0 && (
            <Box className={classes.pending}>
              Debe ingresar al menos una dirección de correo electrónico.
            </Box>
          )}
          {filterOptions.report_automatic && !filterOptions.frequency && (
            <Box className={classes.pending}>
              Debe elegir la frecuencia del reporte automático.
            </Box>
          )}

          {/* El siguiente componente mostrará un mensaje de error */}
          {filterOptions.report_automatic && isPast(filterOptions.dateFrom) && (
            <Box className={classes.pending}>
              Debe ingresar una fecha futura.
            </Box>
          )}

          {
            errorReport && (
              <Box className={classes.pending}>
                {errorReport}
              </Box>
            )
          }
          <Box display='flex' justifyContent='center'>
            {filterOptions.id && (
              <Button
                variant='outlined'
                color='secondary'
                onClick={handlePreDeleteReport}
                className={classes.devicesBtn}
              >
                Eliminar
              </Button>
            )}
            {!filterOptions.id ? (
              <Button
                className={classes.devicesBtn}
                variant='contained'
                color='primary'
                onClick={handleCreate}
                disabled={
                  waiting ||
                    (!firstDataset?.variables || firstDataset?.variables === "") ||
                    (!firstDataset?.nodes || firstDataset?.nodes?.length === 0) ||
                    (filterOptions.report_automatic === true &&
                      filterOptions.emails.length === 0)
                    ? true
                    : false
                }
              >
                Crear
              </Button>
            ) : (
              <Button
                className={classes.devicesBtn}
                variant='contained'
                color='primary'
                onClick={handleEdit}
                disabled={
                  waiting ||
                    (filterOptions.report_automatic && isPast(filterOptions.dateFrom)) ||
                    (!firstDataset?.nodes || firstDataset?.nodes?.length === 0) ||
                    (!firstDataset?.variables || firstDataset?.variables === "") ||
                    (filterOptions.report_automatic === true &&
                      filterOptions.emails.length === 0) ||
                    !filterOptions.chosen_range
                    ? true
                    : false
                }
              >
                Guardar
              </Button>
            )}

            <Button
              variant='contained'
              onClick={togglePanel}
              className={classes.devicesBtn}
            >
              Cancelar
            </Button>
          </Box>
        </Grid>
      </Grid >
      <DevicesDialog
        isOpen={showDevices}
        setIsOpen={setShowDevices}
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        statusNodes={statusNodes}
      />
      <ConfirmationDialog
        isOpen={isDeleteDialogOpen}
        handleConfirm={handleDeleteReport}
        handleCancel={handleDeleteCancel}
        title={`¿Desea eliminar el reporte '${filterOptions?.report_name}'?`}
        content='En caso de confirmar el reporte será eliminado'
      />
      <Dialog
        open={showDatasetFilter}
        onClose={handleCloseDatasetFilter}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DatasetFilter
          filterOptions={filterOptions}
          setFilterOptions={setFilterOptions}
          variables={variables}
          setVariables={setVariables}
          hasSomeVirtualNodes={hasSomeVirtualNodes}
          objectCatalog={objectCatalog}
          selectedDataset={selectedDataset}
          setShowDatasetFilter={setShowDatasetFilter}
          indexDatasetSelected={indexDatasetSelected}
          nodes={nodes}
          automateVars={automateVars}
        />
      </Dialog>
    </>
  );
}

export default Filter;
